<template>
  <div class="container flex_column_start_center">
    <img class="img_tu" src="@/assets/img/img_tu.png" />
    <div class="title">还没安装飞鸭记账？请点击下载</div>
    <div class="btn_box ios_box flex_center_center" @click="openApp_ios()">
      <img src="@/assets/img/ios_icon.png" alt="" />下载iOS版
    </div>
    <div class="btn_box flex_center_center" @click="openApp()">
      <img src="@/assets/img/btn_icon.png" alt="" />下载Android版
    </div>

    <!-- <div class="btn_box ios_box flex_center_center" @click="openWx()">
      <img src="@/assets/img/wx_icon.png" alt="" />飞鸭记账内测用户群
    </div> -->

    <div class="arrowWrap" v-if="isShowArrow" @click="arrowBtn">
      <div class="arrow">
        <img class="arrowImg" src="@/assets/img/jiantou.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlData: {
        apkUrl:
          "http://e687185f-91d6-4721-9aca-1317157a2292.oss.hfhchuang.com/4a2fc85e-0a55-4f7a-8b0e-ce750cf6c5c5.apk", //下载接口
        deepLinkUrl: "altimeter://com.feiya.accounting/open"
      },
      isHidden: false, // 页面是否被隐藏（初始值为false）
      directLoad: true, //控制是否下载
      isShowArrow: false //控制是否显示遮罩层
    };
  },
  mounted() {
    console.log("是否是微信环境", this.is_weixin());
    console.log("是否是ios环境", this.is_IOS());
  },
  created() {
    let isIOS = this.is_IOS();
    if (isIOS) {
      window.location.href =
        "https://apps.apple.com/cn/app/%E9%A3%9E%E9%B8%AD%E8%AE%B0%E8%B4%A6-%E6%B8%85%E7%88%BD%E5%8F%AF%E7%88%B1%E7%9A%84%E5%BF%AB%E9%80%9F%E8%AE%B0%E8%B4%A6app/id6503937278";
      return;
    }
    window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.feiya.accounting&fromcase=70051&g_f=1182517&scenevia=XQYFX";
    // this.urlData.apkUrl = this.$util.getUrlQueryString("apkUrl");
  },
  methods: {
    //判断是否是微信环境
    is_weixin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      }
      return false;
    },
    // 判断是否是IOS环境
    is_IOS() {
      let ua = navigator.userAgent;
      if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true;
      }
      return false;
    },
    // 点击打开APP按钮
    openApp() {
      let isIOS = this.is_IOS();
      if (isIOS) return;
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.feiya.accounting&fromcase=70051&g_f=1182517&scenevia=XQYFX";
      return;
    },
    // 点击打开APP按钮
    openApp_ios() {
      let isIOS = this.is_IOS();
      if (!isIOS) return;
      window.location.href =
        "https://apps.apple.com/cn/app/%E9%A3%9E%E9%B8%AD%E8%AE%B0%E8%B4%A6-%E6%B8%85%E7%88%BD%E5%8F%AF%E7%88%B1%E7%9A%84%E5%BF%AB%E9%80%9F%E8%AE%B0%E8%B4%A6app/id6503937278";
    },
    arrowBtn() {
      this.isShowArrow = false;
    },
    openWx() {
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc51e5999b6c825827";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/css/index/index.css"></style>
<style src="@/assets/css/index/indexDeep.css"></style>



// WEBPACK FOOTER //
// src/view/index/index.vue